// extracted by mini-css-extract-plugin
export default {"container":"t2JcgIO0","card":"EDSl5_KY","logo":"gCCGzafN"};